import type { SymbolKey } from '@/entities/symbol';

import type { SpotHistoryTableColumnType } from '../../types';
import { DATA_COLUMN_WIDTH, MAX_DATA_COLUMN_WIDTH, MIN_DATA_COLUMN_WIDTH } from './constants';

export function getColumnCode(column: SpotHistoryTableColumnType) {
  return column.symbol?.key.Code || column.code || '';
}

export function getColumnSymbolKey(column: SpotHistoryTableColumnType): SymbolKey | null {
  if (column.symbol?.key.Code) return column.symbol.key;
  const code = getColumnCode(column);

  if (!code) return null;

  return {
    Code: code,
    PeriodType: '',
    Period: '',
    TimeRef: ''
  };
}

export function getColumnTitle(column: SpotHistoryTableColumnType) {
  return column.name || column.alias || getColumnCode(column);
}

export function getSpotHistoryColumnId(column: SpotHistoryTableColumnType, index: number) {
  return getColumnCode(column) || `spot-history-column-${index + 1}`;
}

export function clampColumnWidth(width: number) {
  const finiteWidth = Number.isFinite(width) ? width : DATA_COLUMN_WIDTH;
  return Math.min(MAX_DATA_COLUMN_WIDTH, Math.max(MIN_DATA_COLUMN_WIDTH, finiteWidth));
}
